
import { supabase } from '@/integrations/supabase/client';

export interface MacroCurriculum {
  id?: string;
  title: string;
  belt_color: string;
  stripe_count: number;
  content?: string;
  image_url?: string;
  video_url?: string;
  order_index: number;
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
  created_by?: string;
}

export interface MesoCurriculum extends MacroCurriculum {
  key_techniques?: string[];
  learning_objectives?: string[];
}

export const fetchMacroCurriculum = async (): Promise<MacroCurriculum[]> => {
  const { data, error } = await supabase
    .from('roadmap_macro')
    .select('*')
    .order('order_index');
  
  if (error) throw error;
  
  return data.map((item: Record<string, unknown>) => ({
    ...item,
    content: item.content || undefined,
    image_url: item.image_url || undefined,
    video_url: item.video_url || undefined,
    created_by: item.created_by || undefined
  }));
};

export const fetchMesoCurriculum = async (): Promise<MesoCurriculum[]> => {
  const { data, error } = await supabase
    .from('roadmap_meso')
    .select('*')
    .order('order_index');
  
  if (error) throw error;
  
  return data.map((item: Record<string, unknown>) => ({
    ...item,
    content: item.content || undefined,
    image_url: item.image_url || undefined,
    video_url: item.video_url || undefined,
    created_by: item.created_by || undefined,
    key_techniques: item.key_techniques || [],
    learning_objectives: item.learning_objectives || []
  }));
};

export const createMacroCurriculum = async (curriculum: MacroCurriculum): Promise<MacroCurriculum> => {
  const { data, error } = await supabase
    .from('roadmap_macro')
    .insert(curriculum)
    .select()
    .single();
  
  if (error) throw error;
  return data;
};

export const createMesoCurriculum = async (curriculum: MesoCurriculum): Promise<MesoCurriculum> => {
  const { data, error } = await supabase
    .from('roadmap_meso')
    .insert(curriculum)
    .select()
    .single();
  
  if (error) throw error;
  return data;
};

export const updateMacroCurriculum = async (id: string, curriculum: Partial<MacroCurriculum>): Promise<MacroCurriculum> => {
  const { data, error } = await supabase
    .from('roadmap_macro')
    .update(curriculum)
    .eq('id', id)
    .select()
    .single();
  
  if (error) throw error;
  return data;
};

export const updateMesoCurriculum = async (id: string, curriculum: Partial<MesoCurriculum>): Promise<MesoCurriculum> => {
  const { data, error } = await supabase
    .from('roadmap_meso')
    .update(curriculum)
    .eq('id', id)
    .select()
    .single();
  
  if (error) throw error;
  return data;
};

export const deleteMacroCurriculum = async (id: string): Promise<void> => {
  const { error } = await supabase
    .from('roadmap_macro')
    .delete()
    .eq('id', id);
  
  if (error) throw error;
};

export const deleteMesoCurriculum = async (id: string): Promise<void> => {
  const { error } = await supabase
    .from('roadmap_meso')
    .delete()
    .eq('id', id);
  
  if (error) throw error;
};
